<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-6 align-center">
        <h2>{{ isNaccuUser ? $t('memberDataSection.factoryRoles') : $t('memberDataSection.buyingStationRoles') }}</h2>
        <v-spacer></v-spacer>
      </div>

      <v-card elevation="0" class="px-5 pt-4 pb-4 roles-card">
        <div class="d-flex align-center mb-4">
          <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" outlined dense hide-details
            :placeholder="$t('search')" style="max-width: 320px"></v-text-field>
          <v-spacer></v-spacer>
          <div v-if="filteredRoles.length" class="d-flex align-center">
            <div class="py-1 title">{{ from }} - {{ to }} {{ $t('of') }} {{ filteredRoles.length }}</div>
            <v-btn class="mx-2" fab small outlined color="primary" :disabled="page <= 1" @click="page--">
              <v-icon dark>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn class="mx-2" fab small outlined color="primary" :disabled="page >= totalPages" @click="page++">
              <v-icon dark>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>

        <v-data-table :headers="headers" :items="pagedRoles" :loading="loading" hide-default-footer
          :items-per-page="-1" item-key="id" class="roles-table">
          <template #item.name="{ item }">
            <span class="font-weight-medium">{{ item.name }}</span>
          </template>
          <template #item.actions="{ item }">
            <a class="view-permissions font-weight-medium" @click="viewPermissions(item)">
              {{ $t('memberDataSection.viewPermissions') }}
            </a>
          </template>
          <template #no-data>
            <div class="text-center py-8 grey--text">{{ $t('memberDataSection.noConnectedUsers') }}</div>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import RoleMixin from "@/mixins/RoleMixin";
import loadingMixin from "@/mixins/LoadingMixin";
import { isKenyaClient } from "@/utils";
import BuyingStationService from "@/_services/BuyingStationService";

export default {
  name: "BuyingStationRoles",
  mixins: [RoleMixin, loadingMixin],
  data() {
    return {
      roles: [],
      loading: false,
      search: "",
      page: 1,
      perPage: 10,
    };
  },
  watch: {
    search() {
      this.page = 1;
    },
  },
  computed: {
    isNaccuUser() {
      return isKenyaClient();
    },
    breadcrumbs() {
      return [
        { text: this.$t("memberDataSection.factories"), disabled: false, to: { name: "CoffeeBuyingStation" } },
        { text: this.isNaccuUser ? this.$t("memberDataSection.factoryRoles") : this.$t("memberDataSection.buyingStationRoles"), disabled: true },
      ];
    },
    headers() {
      return [
        { text: this.$t("memberDataSection.stationRole"), value: "name", sortable: false },
        { text: "", value: "actions", sortable: false, align: "end" },
      ];
    },
    filteredRoles() {
      const term = (this.search || "").trim().toLowerCase();
      if (!term) return this.roles;
      return this.roles.filter((r) => (r.name || "").toLowerCase().includes(term));
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.filteredRoles.length / this.perPage));
    },
    from() {
      return this.filteredRoles.length ? (this.page - 1) * this.perPage + 1 : 0;
    },
    to() {
      return Math.min(this.page * this.perPage, this.filteredRoles.length);
    },
    pagedRoles() {
      const start = (this.page - 1) * this.perPage;
      return this.filteredRoles.slice(start, start + this.perPage);
    },
  },
  created() {
    this.getRoles();
  },
  methods: {
    async getRoles() {
      this.loading = true;
      try {
        const res = await BuyingStationService.getStationRoles();
        this.roles = (res && res.data) || [];
      } catch (e) {
        this.roles = [];
        this.$notify({ text: (e && e.data && e.data.message) || this.$t("memberDataSection.registrationFailed"), type: "error" });
      } finally {
        this.loading = false;
      }
    },
    viewPermissions(item) {
      this.$router.push({
        name: "CoffeeBuyingStationRolePermissions",
        params: { roleId: item.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.roles-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.view-permissions {
  color: var(--primary-color, #117443);
  cursor: pointer;
}
::v-deep .roles-table .v-data-table-header {
  background-color: $secondary-color;
}
::v-deep .roles-table .v-data-table-header th {
  color: #fff !important;
  text-transform: uppercase;
}
</style>
